import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=0fe0b54e&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Option: require('/home/runner/work/myody_front/myody_front/components/option/Option.vue').default,Select: require('/home/runner/work/myody_front/myody_front/components/select/Select.vue').default,FormItem: require('/home/runner/work/myody_front/myody_front/components/form/FormItem.vue').default,Form: require('/home/runner/work/myody_front/myody_front/components/form/Form.vue').default,Button: require('/home/runner/work/myody_front/myody_front/components/button/Button.vue').default,Link: require('/home/runner/work/myody_front/myody_front/components/link/Link.vue').default,FormViewItem: require('/home/runner/work/myody_front/myody_front/components/form/FormViewItem.vue').default,FormView: require('/home/runner/work/myody_front/myody_front/components/form/FormView.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
